import {launchDarkly} from 'utils/launchDarkly';

// swaps the task details page for the redesigned one (see components/taskdetails); the classic page
// it replaces is in components/taskdetails-remake
export const TASK_DETAILS_REDESIGN_FLAG = 'fe-task-details-redesign';

/**
 * Read at render by the page's own wrapper (see TaskDetailsWrapper.component), so the page decides
 * which of its two renderings it is. The router is built before LaunchDarkly is ready, so it cannot.
 */
export const isTaskDetailsRedesignEnabled = (): boolean =>
    launchDarkly.userClient?.variation(TASK_DETAILS_REDESIGN_FLAG, false) ?? false;
